export default __webpack_public_path__ + "static/media/offline_mode.6d914549.svg";